import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Grid} from '@material-ui/core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMessage, faTimesCircle} from '@fortawesome/pro-solid-svg-icons';
import LocalizedText from 'commons/LocalizedText/LocalizedText';

const useStyles = makeStyles((theme) => ({
  header: {
    padding: '0 15px',
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    alignItems: 'center',
    height: '75px',
    boxShadow: theme.palette.shadow.hover
  },
  title: {
    color: 'white',
    fontSize: '24px'
  }
}));

const NoteHeader = ({onCloseButtonClick}) => {
  const classes = useStyles();

  return (
    <Grid className={classes.header} container justifyContent="space-between">
      <Grid item>
        <Grid container spacing={2}>
          <Grid item><FontAwesomeIcon color="white" icon={faMessage} size="xl" style={{paddingTop: '40%'}}/></Grid>
          <Grid item><LocalizedText className={classes.title}>productTestNotes</LocalizedText></Grid>
        </Grid>
      </Grid>
      <Grid item style={{cursor: 'pointer'}}>
        <FontAwesomeIcon color="white" icon={faTimesCircle} onClick={() => {onCloseButtonClick()}} size="2xl"/>
      </Grid>
    </Grid>

  );
};

export default NoteHeader;